import { useEffect, useState } from 'react';

const useIsBot = () => {
  const [isBot, setIsBot] = useState(false);

  useEffect(() => {
    const checkIsBot = () => {
      if (typeof navigator === 'undefined') {
        return false;
      }

      const botPatterns = [
        'Google', 'AdsBot', 'Googlebot', 'bingbot', 'YandexBot', 'DuckDuckBot',
        'facebookexternalhit', 'TwitterBot', 'LinkedInBot',
        'bot', 'crawler', 'spider', 'archiver',
        'UptimeRobot', 'pingdom', 'Monitor',
        'http', 'Bot', 'crawl', 'slurp', 'spider',
        'Alexa', 'Yahoo', 'Baidu', 'Teoma',
        'HeadlessChrome', 'PhantomJS', 'Puppeteer'
      ];

      const userAgent = navigator.userAgent.toLowerCase();

      if (!userAgent) {
        return true;
      }

      return botPatterns.some(pattern => userAgent.includes(pattern.toLowerCase()));
    };

    setIsBot(checkIsBot());
  }, []);

  return isBot;
};

export default useIsBot;